export default __webpack_public_path__ + "static/media/join-call.12e2a0ab.mp3";